// Progressive enhancement: SSR content remains visible without script or animation support.
const reduce = window.matchMedia("(prefers-reduced-motion: reduce)");
if (!reduce.matches && "IntersectionObserver" in window) {
  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        observer.unobserve(entry.target);
        if (!reduce.matches && entry.target.animate)
          entry.target.animate(
            [
              { opacity: 0, transform: "translateY(14px)" },
              { opacity: 1, transform: "translateY(0)" },
            ],
            { duration: 550, easing: "cubic-bezier(.2,.7,.2,1)" },
          );
      }
    },
    { threshold: 0.08 },
  );
  document
    .querySelectorAll(
      ".hero > div:first-child, .how, .journal-example, .demo-landing, .agent-library, .ios, .faq, .landing-footer",
    )
    .forEach((el) => observer.observe(el));
}
